import { z } from 'zod';
export const Answer = z.enum(['yes', 'partial', 'no']);
export const TaskStatus = z.enum(['not_started', 'in_progress', 'complete']);
export const Track = z.enum(['dc', 'ci']);
export const Level = z.union([z.literal(1), z.literal(2), z.literal(3)]);
export const OrgSize = z.enum(['1-49', '50-249', '250-999', '1000+']);
export const Scopes = ['read:status','read:assessment','write:assessment','read:tasks','write:tasks','read:evidence','write:evidence','ai:ask','ai:personas','ai:generate','ai:analyse','admin'] as const;
export type Scope = typeof Scopes[number];
export const LEVEL_LABELS: Record<number, string> = { 0: 'Not Started', 1: 'Committed', 2: 'Employer', 3: 'Leader' };
export { PUBLIC_EMAIL_DOMAINS, isPublicEmailDomain } from './public-email-domains.js';
export { assessmentTasks, taskProgressAnswer, taskEvidenceRequirements, PROGRESS_LABELS } from './assessment-progress.js';
